import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { InfoMessageModule } from '../info-message/info-message.module';
import { InvoiceComponent } from './invoice.component';
import { MobileDropdownModule } from '../mobile-dropdown/mobile-dropdown.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlertModule } from '../alert/alert.module';
import { TimerFormatterModule } from '../timer-formatter/timer-formatter.module';




@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
    MatSnackBarModule,
    MobileDropdownModule,
    MatProgressSpinnerModule,
    AlertModule,
    TimerFormatterModule,
    InfoMessageModule
  ],
  exports: [
    InvoiceComponent
  ],
  providers: [
  ],
  declarations: [
    InvoiceComponent
  ]
})
export class InvoiceModule { }
